import { ApiCityDistrict } from '../api-types/city-district.api';
import { CityDistrict } from '../app-types/city-district.app';

/**
 * Converts the API version of the city district to the internal app version.
 * @param input API version of the city district
 * @returns Internal version of the city district used internally inside the app
 */
export const transformApiCityDistrictToAppCityDistrict = (input: ApiCityDistrict): CityDistrict => {
	return {
		id: input.id,
		display: input.display,
		initial: input.initial,
		remark: input.remark,
		specialistIntegrationService: input.specialistIntegrationService,
	};
};
